import { render, staticRenderFns } from "./ButtonBoxMain.vue?vue&type=template&id=0dffaf3f"
import script from "./ButtonBoxMain.vue?vue&type=script&lang=js"
export * from "./ButtonBoxMain.vue?vue&type=script&lang=js"
import style0 from "./ButtonBoxMain.vue?vue&type=style&index=0&id=0dffaf3f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports